import React from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../../../client';
import { __ } from '../../../../i18n/l10n';
import { ExternalArrow } from '../../assets/svg';
import MissionCardContainer from '../MissionCard/MissionCardContainer';

const Wrapper = styled.div`
  position: relative;
  padding: 0.67em;
`;

const StyledMissionCardContainer = styled(MissionCardContainer)`
  width: 100%;

  margin-bottom: 0.67em;
`;

const MoreMissionsCard = styled.div`
  border-radius: 0.8em;
  background: #0f1118;
  color: white;
  padding: 1.2em;
  //margin: 0.4em;
`;

const labelsSharedStyle = css`
  padding: 0em 10%;
  text-align: center;
  margin-bottom: 1em;
`;

const MoreMissionsCardLabel1 = styled.div`
  ${labelsSharedStyle}
`;

const MoreMissionsCardLabel2 = styled.div`
  ${labelsSharedStyle}
`;

const MoreMissionCardButton = styled.div`
  width: 100%;
  display: flex;
  padding: 0.5em;
  background: #1e212a;
  border-radius: 50em;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;

  ${!Target.__MOBILE__
    ? css`
        &:hover {
          transition: filter 200ms ease-in-out;
          filter: brightness(120%);
        }
      `
    : undefined}
`;

const MoreMissionCardButtonLabel = styled.div`
  position: relative;
  padding-right: 2.5em;
  padding-left: 2em;
  font-weight: bold;
`;

const MoreMissionCardButtonIcon = styled(ExternalArrow)`
  position: absolute;
  width: 1em;
  height: 1em;
  right: 1em;
  top: 50%;
  transform: translateY(-50%);
`;
type MissionsCardsListProps = {
  className?: string;
  missionIds: Array<number>;
  onMoreMissionsClick: () => void;
};

const MissionsCardsList = ({ className = '', missionIds, onMoreMissionsClick }: MissionsCardsListProps) => (
  <Wrapper className={className}>
    {missionIds?.map((missionId) => (
      <StyledMissionCardContainer key={`mission-card-${missionId}`} missionId={missionId} />
    )) ?? null}
    <MoreMissionsCard>
      <MoreMissionsCardLabel1>
        {__('Want to check out all the promotions Winamax has to offer?')}
      </MoreMissionsCardLabel1>
      <MoreMissionsCardLabel2>{__('You can do so right here! :index_vers_le_bas:')}👇</MoreMissionsCardLabel2>

      <MoreMissionCardButton onClick={onMoreMissionsClick}>
        <MoreMissionCardButtonLabel>
          {__('Permanent and past promotions')}
          <MoreMissionCardButtonIcon />
        </MoreMissionCardButtonLabel>
      </MoreMissionCardButton>
    </MoreMissionsCard>
  </Wrapper>
);

export default MissionsCardsList;
